import { makeStyles } from '@mui/styles';
// colors
import { theme } from '../../../../../packages/theme';
import { colors } from '../../../../../packages/colors';

export const useStyles = makeStyles({
  wrapper: {
    gap: 16,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 8,
    marginBottom: 8,
  },
  error: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.error.main,
  },
  time: {
    backgroundColor: colors.white,
  },
  removeBtn: {
    minWidth: 48,
    height: 48,
    '& svg': {
      width: 20,
      '& path': {
        fill: colors.destructive500,
      },
    },
  },
  timeSelectionMenu: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      paddingLeft: '0px !important',
      paddingRight: '32px !important',
      margin: 16,
    },
  },
});
